var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data),function(card,index){return _c('div',{key:index,staticStyle:{"display":"inline-block !important"}},[_c('vs-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({
        title: `${card.tooltip}`,
        placement: 'top',

        customClass: 'font_tooltip',
      }),expression:"{\n        title: `${card.tooltip}`,\n        placement: 'top',\n\n        customClass: 'font_tooltip',\n      }"}],key:index,staticClass:"mx-1 px-0",style:({ boxShadow: _vm.activeCard === index ? `inset 0 0 0 2px ${card.color}` : 'none' }),attrs:{"icon":"","color":card.type},on:{"click":function($event){return _vm.toggleActive(index)}}},[_c('i',{class:`fas fa-${card.iconName} }`})])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }